import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-medical-docs-download-block-component',
    templateUrl: './medical-docs-download-block.component.html',
    styleUrls: []
})
export class MedicalDocsDownloadBlockComponent {
    @Input() downloadDescription =
        'documentselection.documentlist.buttons.showlist.details';
    @Output() isListDownload: EventEmitter<boolean> = new EventEmitter();
    @Output() download: EventEmitter<boolean> = new EventEmitter();
    @Output() triggerDownloadCompleted: EventEmitter<void> = new EventEmitter();
    downloadFile(): void {
        this.isListDownload.emit(true);
        this.download.emit(true);
        this.triggerDownloadCompleted.emit();
    }
}
